import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Card } from 'semantic-ui-react';
import i18next from 'i18next';

class LayoutToggler extends Component {
    render() {
        const isRtl = i18next.dir() === 'rtl';

        return (
            <Card
                style={{
                    position: 'fixed',
                    left: `${isRtl ? 0 : undefined}`,
                    right: `${isRtl ? undefined : 0}`,
                    bottom: 0, zIndex: 99,
                    margin: 10,
                    width: 'fit-content',
                    textAlign: 'center'
                }}
            >
                <Card.Content>
                    <Button.Group>
                        <Button icon color={this.props.layout === 'portrait' ? 'blue' : undefined} onClick={() => this.props.onLayoutChange('portrait')}>
                            <Icon name="file image outline" size="big" style={{ width: '65px' }} />
                        </Button>
                        <Button.Or text={i18next.t('or')} />
                        <Button icon color={this.props.layout === 'landscape' ? 'blue' : undefined} onClick={() => this.props.onLayoutChange('landscape')}>
                            <Icon name="image outline" size="big" style={{ width: '65px' }} />
                        </Button>
                    </Button.Group>
                </Card.Content>
            </Card>
        );
    }
}

LayoutToggler.propTypes = {
    
    layout: PropTypes.string,
    onLayoutChange: PropTypes.func,
    isRtl: PropTypes.bool
};

export default LayoutToggler;
